export enum DashboardContainerCodes {
  PLAN = 'level1_plans',
  NAVIGATOR = 'level1_navigator',
}
